import { itemUpdateApi } from "../../api/item/itemUpdateApi"

type PayloadShape = Parameters<typeof itemUpdateApi>[0]

export async function itemUpdateService(payload: PayloadShape, token: string) {
	if (payload.update?.rate) payload.update.rate = +payload.update.rate
	return await itemUpdateApi(payload, token)
}
